<template>
  <router-view/>
</template>
<script>
    export default {
    name: 'incidenciasIndex'
    }
</script>

<style scoped>

</style>
